export default __webpack_public_path__ + "static/premio2_CO-37df050a3972ff38f2d95cec3e49b094.png";